import type { AddressAutocompleteOption } from './addressAutocompleteOption.interface';
import { ScreeningResult } from '../../features/RenterInvite/constants';
import { RentCoverageTypes, SecurityDepositTypes } from '../../constants/CoverageType';
import type { CoveragePricing } from '@/shared/types';

export enum RenterInviteType {
  SMBInviteOldCustomCoverage = 'SMB_Invite_old_custom_coverage',
  SMBInviteNewLimitedSdr = 'SMB_Invite_new_limited_sdr',
}

// The form stores an AddressAutocompleteOption at runtime via the autocomplete onChange.
// Partial<> satisfies the Yup resolver's narrow inferred type while giving access to all fields.
export type Address = Partial<AddressAutocompleteOption> & {
  monolith_building_id: number;
};

export interface Renter {
  screeningStatus?: ScreeningResult | '';
  address: Address;
  unit: string;
  leaseStartDate: Date;
  leaseEndDate: Date;
  grossMonthlyRent: number;
  prepaidRent?: number;
  freeRent?: number;
  applicantEmails: { value: string }[];
  rentCoverage: RentCoverageTypes;
  leaseGuaranteeMonthsOverride?: number;
  securityDepositCoverage: SecurityDepositTypes;
  securityDepositReplacementAmountOverride?: number;
  customCoverage?: boolean;
  includeDepositCoverage?: boolean;
  selectedSmbPricing?: CoveragePricing;
  selectedCoverageRuleId?: string;
}

export enum CoverageType {
  RentCoverage = 'rentCoverage',
  SecurityDepositCoverage = 'securityDepositCoverage',
}
